import { render, staticRenderFns } from "./v-header-yanshi.vue?vue&type=template&id=53131816&scoped=true"
import script from "./v-header-yanshi.vue?vue&type=script&lang=js"
export * from "./v-header-yanshi.vue?vue&type=script&lang=js"
import style0 from "./v-header-yanshi.vue?vue&type=style&index=0&id=53131816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53131816",
  null
  
)

export default component.exports